import CompanyLinks from './CompanyLinks';
import DealLinks from './DealLinks';
import JobLinks from './JobLinks';
import PersonLinks from './PersonLinks';
import type {
  CompanyLink,
  DealLink,
  JobLink,
  MessageAttachment,
  PersonLink,
} from './structs';
import {LinksContainer} from './styles';

interface Props {
  agencyId: number;
  contextEmails: readonly string[];
  personLinks: PersonLink[];
  setPersonLinks: (personLinks: PersonLink[]) => void;
  companyLinks: CompanyLink[];
  setCompanyLinks: (companyLinks: CompanyLink[]) => void;
  jobLinks: JobLink[];
  setJobLinks: (jobLinks: JobLink[]) => void;
  dealLinks: DealLink[];
  setDealLinks: (dealLinks: DealLink[]) => void;
  attachments: MessageAttachment[];
}

const EntityLinks = ({
  agencyId,
  contextEmails,
  personLinks,
  setPersonLinks,
  companyLinks,
  setCompanyLinks,
  jobLinks,
  setJobLinks,
  dealLinks,
  setDealLinks,
  attachments,
}: Props) => {
  return (
    <LinksContainer>
      <PersonLinks
        agencyId={agencyId}
        recipientEmails={contextEmails}
        personLinks={personLinks}
        setPersonLinks={setPersonLinks}
        attachments={attachments}
      />
      <CompanyLinks
        agencyId={agencyId}
        companyLinks={companyLinks}
        setCompanyLinks={setCompanyLinks}
        attachments={attachments}
      />
      <JobLinks
        agencyId={agencyId}
        jobLinks={jobLinks}
        setJobLinks={setJobLinks}
        attachments={attachments}
      />
      <DealLinks
        agencyId={agencyId}
        dealLinks={dealLinks}
        setDealLinks={setDealLinks}
        attachments={attachments}
      />
    </LinksContainer>
  );
};

export default EntityLinks;
